import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import I18nProvider from './I18nProvider'
import MainSwitch from './MainSwitch'

// Init fontawesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { fal } from 'fontawesome-pro-light-svg-icons'
import { fas } from 'fontawesome-pro-solid-svg-icons'
library.add(fal, fas)



const Root = ({ store }) => (
	<Provider store={store}>
		<I18nProvider>
			<MainSwitch />
		</I18nProvider>
	</Provider>
)

Root.propTypes = {
	store: PropTypes.object.isRequired,
}
export default Root


// WEBPACK FOOTER //
// ./src/containers/Root.prod.js